// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-modal-content {
  max-width: 720px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.terms-version {
  color: var(--ink-3);
  font-size: 0.85rem;
  margin-bottom: 1.5rem;
}

.terms-section {
  margin-bottom: 1.5rem;
}

.terms-section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 0.5rem;
}

.terms-section-paragraph {
  color: var(--ink-3);
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 0.75rem;
  white-space: pre-line;
}

.terms-catalog-copy {
  color: var(--ink-3);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.terms-catalog-link {
  color: var(--blue);
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/terms-and-conditions.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":[".terms-modal-content {\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.terms-version {\n  color: var(--ink-3);\n  font-size: 0.85rem;\n  margin-bottom: 1.5rem;\n}\n\n.terms-section {\n  margin-bottom: 1.5rem;\n}\n\n.terms-section-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--ink);\n  margin-bottom: 0.5rem;\n}\n\n.terms-section-paragraph {\n  color: var(--ink-3);\n  font-size: 0.9rem;\n  line-height: 1.6;\n  margin-bottom: 0.75rem;\n  white-space: pre-line;\n}\n\n.terms-catalog-copy {\n  color: var(--ink-3);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.terms-catalog-link {\n  color: var(--blue);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
